// extracted by mini-css-extract-plugin
export default {"informationView":"Rules_informationView__wo5Y9"};